<ul class="list-none p-0 m-0 flex flex-col gap-0.5" role="group">
  @for (node of nodes(); track node.slug) {
    <li
      role="treeitem"
      [attr.aria-selected]="isSelected(node.slug)"
      [attr.aria-expanded]="hasChildren(node) ? isExpanded(node.slug) : null"
      [style.padding-left.px]="depth() * 12"
    >
      <div class="flex min-w-0 items-center gap-1">
        @if (hasChildren(node)) {
          <button
            type="button"
            class="btn btn-ghost btn-xs btn-square shrink-0 min-h-8 min-w-8"
            [attr.aria-label]="
              isExpanded(node.slug)
                ? 'Свернуть «' + node.name + '»'
                : 'Развернуть «' + node.name + '»'
            "
            (click)="onToggle(node.slug, $event)"
          >
            <lucide-icon
              [name]="isExpanded(node.slug) ? 'chevron-down' : 'chevron-right'"
              class="h-4 w-4 stroke-current"
            />
          </button>
        } @else {
          <span class="inline-block h-8 w-8 shrink-0" aria-hidden="true"></span>
        }
        <a
          class="flex min-w-0 flex-1 items-center rounded-lg px-2 py-2 text-sm font-medium transition-colors hover:bg-base-300"
          routerLinkActive="bg-primary/10"
          [routerLink]="categoryLink(node.slug)"
          (click)="onCategoryClick()"
        >
          <span class="truncate">{{ node.name }}</span>
        </a>
      </div>
      @if (hasChildren(node) && isExpanded(node.slug)) {
        <app-blog-sidebar-nav-tree
          [nodes]="node.children"
          [depth]="depth() + 1"
          [expandedSlugs]="expandedSlugs()"
          [activeCategorySlug]="activeCategorySlug()"
          (toggleExpand)="toggleExpand.emit($event)"
          (categoryNavigate)="categoryNavigate.emit()"
        />
      }
    </li>
  }
</ul>
